/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { SidebarGlobal } from "./_Sidebar";
import Auth from "../shared/Auth";
import Icon from "./Icon";

class Administration extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
        SidebarGlobal.clearSubNav();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    render() {
        return <div className="container-fluid">
            <h1>Administration</h1>
            <div className="list-group">
                {Auth.hasRole('account-manager') && <Link to="/account" className="list-group-item"><Icon icon="faHouse" /> Accounts</Link>}
                {Auth.hasRole('admin') && <Link to="/contact" className="list-group-item"><Icon icon="faAddressBook" /> Contacts</Link>}
                {Auth.hasRole('admin') && <Link to="/manage/document-category" className="list-group-item"><Icon icon="faFolderOpen" /> Document Categories</Link>}
                {Auth.hasRole('admin') && <Link to="/form/type/list" className="list-group-item"><Icon icon="faBorderNone" /> Forms</Link>}
                {Auth.hasRole('admin') && <Link to="/group" className="list-group-item"><Icon icon="faUsersRectangle" /> Groups</Link>}
                {Auth.hasRole('admin') && this.state.MODEL === 'LIS' && <Link to="/lab/manager" className="list-group-item"><Icon icon="faGears" /> Lab Management</Link>}
                {Auth.hasRole('admin') && <Link to="/manufacturer/list" className="list-group-item"><Icon icon="faIndustry" /> Manufacturers</Link>}
                {false && Auth.hasRole('manager') && <Link to="/medical-procedure" className="list-group-item"><Icon icon="faBedPulse" /> Medical Procedures</Link>}
                {Auth.hasRole('admin') && <Link to="/manage/next-action" className="list-group-item"><Icon icon="faForward" /> Next Actions</Link>}
                {Auth.hasRole('admin') && <Link to="/organization" className="list-group-item"><Icon icon="faSitemap" /> Organizations</Link>}
                {Auth.hasRole('admin') && <Link to="/practice" className="list-group-item"><Icon icon="faStethoscope" /> Practices</Link>}
                {Auth.hasRole('admin') && <Link to="/product" label="Products" className="list-group-item"><Icon icon="faBox" /> Products</Link>}
                {Auth.hasRole('manager') && <Link to="/provider" className="list-group-item"><Icon icon="faUserDoctor" /> Providers</Link>}
                {Auth.hasRole('admin') && <Link to="/settings" className="list-group-item"><Icon icon="faToolbox" /> Settings</Link>}
                {Auth.hasRole('survey') && <Link to="/survey" className="list-group-item"><Icon icon="faCircleQuestion" /> Survey</Link>}
                {Auth.hasRole('!') && <Link to="/role" className="list-group-item"><Icon icon="faBuildingShield" /> Roles</Link>}
                {Auth.hasRole('admin') && <Link to="/user" className="list-group-item"><Icon icon="faUsers" /> Users</Link>}
                {Auth.hasRole('manager') && <Link to="/workflow" className="list-group-item"><Icon icon="faArrowsTurnToDots" /> Workflows</Link>}
                {Auth.hasRole('admin') && <Link to="/auditlog" className="list-group-item"><Icon icon="faBarsStaggered" /> Audit Log</Link>}
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(Administration);